import type { PfileImageIngestReq } from '@lib2/model/ingest/PfileImageIngestReq';
import type { ClientIngest } from '@/lib/types/Upload';
import { webApi } from './WebApi';

export class PfileApi {
  static async createIngestPfileImage(
    cId: number,
    req: PfileImageIngestReq
  ): Promise<ClientIngest> {
    return webApi.post<ClientIngest>('pfile/ingest-pfile-image', { cId }, req);
  }

  static async deletePfiles(cId: number, fileIds: number[]): Promise<void> {
    return webApi.post<void>('pfile/delete', { cId }, { fileIds });
  }
}
